/* eslint-disable react/jsx-no-target-blank */
import {useEffect, useState} from 'react'
import clsx from 'clsx'
import {Modal} from 'react-bootstrap'
import {
  APP_VERSION_UPDATE_EVENT,
  CURRENT_APP_BUILD_ID,
  CURRENT_APP_VERSION,
  AppVersionUpdateDetail,
  AppVersionPayload,
  clearPendingAppVersion,
  fetchServerAppVersion,
  getVersionId,
  isNewAppVersionAvailable,
  readPendingAppVersion,
  reloadWithVersion,
} from '../../../../app/appVersion'
import {brandCopyright, brandName, onTSP, isTSP} from '../../../helpers'
import './SidebarFooter.css'
// import {Offline, Online} from 'react-detect-offline'

const SidebarFooter = () => {
  const [checkingVersion, setCheckingVersion] = useState(false)
  const [serverVersion, setServerVersion] = useState<AppVersionPayload | undefined>()
  const [versionMessage, setVersionMessage] = useState('')
  const [showUpdateModal, setShowUpdateModal] = useState(false)
  const serverVersionId = getVersionId(serverVersion)
  const hasNewVersion = isNewAppVersionAvailable(serverVersion)

  useEffect(() => {
    const pendingVersion = readPendingAppVersion()
    if (isNewAppVersionAvailable(pendingVersion)) {
      setServerVersion(pendingVersion)
      setVersionMessage('نسخه جدید آماده است')
    }

    const handleVersionUpdate = (event: Event) => {
      const detail = (event as CustomEvent<AppVersionUpdateDetail>).detail
      if (isNewAppVersionAvailable(detail?.payload)) {
        setServerVersion(detail.payload)
        setVersionMessage('نسخه جدید آماده است')
      }
    }

    window.addEventListener(APP_VERSION_UPDATE_EVENT, handleVersionUpdate)
    return () => window.removeEventListener(APP_VERSION_UPDATE_EVENT, handleVersionUpdate)
  }, [])

  const checkVersion = async () => {
    setCheckingVersion(true)
    setVersionMessage('')
    try {
      const payload = await fetchServerAppVersion()
      const payloadHasNewVersion = isNewAppVersionAvailable(payload)
      setServerVersion(payload)
      setVersionMessage(payloadHasNewVersion ? 'نسخه جدید آماده است' : 'بروز است')
      if (payloadHasNewVersion) {
        setShowUpdateModal(true)
      } else {
        clearPendingAppVersion()
      }
    } catch {
      setVersionMessage('خطا در بررسی نسخه')
    } finally {
      setCheckingVersion(false)
    }
  }

  const updateVersion = () => {
    clearPendingAppVersion()
    reloadWithVersion(serverVersionId || CURRENT_APP_BUILD_ID, true)
  }

  const versionButtonClick = () => {
    if (hasNewVersion) {
      setShowUpdateModal(true)
      return
    }

    checkVersion()
  }

  return (
    <>
      <div
        className='app-sidebar-footer flex-column-auto pt-2 pb-6 px-6 text-gray-400 text-center w-100'
        id='kt_app_sidebar_footer'
      >
        <div className='d-flex flex-column text-center'>
          {!isTSP && (
            <span className='fw-bold' style={{direction: 'rtl', display: 'inline-block'}}>
              {brandCopyright}
            </span>
          )}
          <span className='text-center w-100 englishText'>
            <button
              type='button'
              className={clsx(
                'btn btn-sm px-2 py-1 fs-9 mp-app-version-button',
                hasNewVersion
                  ? 'btn-warning text-dark mp-app-version-button--new'
                  : 'btn-light border border-gray-300 text-gray-700'
              )}
              title={`Build: ${CURRENT_APP_BUILD_ID}`}
              disabled={checkingVersion}
              onClick={versionButtonClick}
            >
              <i
                className={clsx(
                  'las fs-6 me-1',
                  checkingVersion ? 'la-spinner la-spin' : hasNewVersion ? 'la-bell' : 'la-sync'
                )}
              ></i>
              V {CURRENT_APP_VERSION}
              {hasNewVersion && <span className='ms-1'>جدید</span>}
            </button>
            {versionMessage && (
              <span
                className={clsx(
                  'd-block mt-1 fs-9',
                  hasNewVersion
                    ? 'text-warning'
                    : versionMessage.includes('خطا')
                    ? 'text-danger'
                    : 'text-muted'
                )}
              >
                {versionMessage}
              </span>
            )}
            {/* <span className='ms-3' title='آنلاین'>
            <i className='las la-wifi me-5 fs-4 text-success'></i>
          </span> */}
          </span>
          {/* <Online>
        </Online>
        <Offline>
          <span className='text-danger' title='آفلاین'>
            <i className='las la-plug me-3 fs-4 text-danger'></i>
            آفلاین
          </span>
        </Offline> */}
        </div>
        {/* {onTSP && window.location.href.includes('sam') && (
        <div className='mt-3'>
          پشتیبانی{' '}
          <a href='tel:02151721000' className='text-left ms-3' dir='ltr'>
            021-51 72 1000
          </a>
        </div>
      )} */}
        {onTSP && window.location.href.includes('ava') && (
          <div className='mt-3'>
            پشتیبانی{' '}
            <a href='tel:02191080080' className='text-left ms-3' dir='ltr'>
              021-42 36 4000
            </a>
          </div>
        )}
      </div>

      <Modal show={showUpdateModal && hasNewVersion} onHide={() => setShowUpdateModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>نسخه جدید آماده است</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='d-flex align-items-start gap-3'>
            <span className='mp-app-version-modal-icon'>
              <i className='las la-download'></i>
            </span>
            <div>
              <p className='fw-bold text-gray-900 mb-2'>
                نسخه جدید پنل {brandName} آماده دریافت است.
              </p>
              <p className='text-gray-700 mb-0'>
                با دریافت نسخه جدید، صفحه یک بار بارگذاری می‌شود و آخرین فایل‌های برنامه جایگزین
                می‌شوند.
              </p>
              <div className='mt-3 englishText text-muted fs-8' dir='ltr'>
                Current: {CURRENT_APP_VERSION}
                {serverVersion?.version && <> | New: {serverVersion.version}</>}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-light' onClick={() => setShowUpdateModal(false)}>
            بعدا
          </button>
          <button type='button' className='btn btn-primary' onClick={updateVersion}>
            دریافت نسخه جدید
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export {SidebarFooter}
